import {
  EarningsInsightFilterResponse,
  earningsInsights,
  EarningsInsightsFilterRequest,
} from '@toggle/toggle';

import { apiFetch } from '~/utils/api-fetch/apiFetch';

export const getEarningsInsightsForChart = async (
  payload: EarningsInsightsFilterRequest
) => {
  const { path, schema } = earningsInsights.postEarningsInsightFilter;

  const cleanedPayload = Object.fromEntries(
    Object.entries(payload).filter(([_, value]) => value !== undefined)
  ) as EarningsInsightsFilterRequest;

  return await apiFetch<EarningsInsightFilterResponse>(path, {
    method: 'post',
    body: cleanedPayload,
    schema,
  });
};
